import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { GlobalDataSharingService } from "../../services/globaldatasharing.service";
import { OfferService } from "../../services/offer.service";
import { NgxSpinnerService } from 'ngx-spinner';
import { NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-editkumiteProfessionData',
  templateUrl: './kumiteProfessionData.component.html',
  styleUrls: ['./kumiteProfessionData.component.css']
})
export class KumiteProfessionDataComponent implements OnInit {

  constructor(  private spinner: NgxSpinnerService,private router: Router, private route: ActivatedRoute,  private offerService: OfferService,private dataSharingService: GlobalDataSharingService) { }

  formModel: any = {
    loggedinUserRole: "",
    memberID: "",
    memberName: "",
    memberIDDisbaled:"",
    memberNameDisbaled: "",
    contactNo:"",
    rcc: "",
    groupLead: "",
    fieldofWork: "",
    subField: "",
    qualification: "",
    businessOrService: "",
    position: "",
    workingOrRetired: "",
    specilization: "",
    details1: "",
    details2: "",
    details3: "",
    details4: "",
    details5: "",
    details6: "",
    details7: "",
    details8: "",
    details9: "",
    details10: "",
    message: "",
    kumiteProfessionDataID: "",
    addNewRec:"",
  };

  loggedInUserData = [];
  currMemberItem = [];
  queryMDetails = [];
  allKumiteProfessionData = [];
  isLoading = false;
  currMemID = 0;
  fieldWorkDetails = [];
  subfieldWorkDetailsData = [];
  allSubfieldWorkDetailsData = [];
  qualificationDetails = [];
  positionDetails = [];
  selectedFieldWorkObj = {};
  selectedSubFieldWorkObj = {};
  selectedQualificationObj = {};
  selectedPositionObj = {};
  selectedWorkingOrRetiredObj = {};
  selectedBusinessOrServiceObj = {};
  workingOrRetiredArray = [];
  businessOrServiceArray = [];


  ngOnInit() {
    this.formModel.loggedinUserRole = localStorage.getItem("loggedinUserRole");
    this.loggedInUserData = this.dataSharingService.getLoggedInUserData();
    this.queryMDetails = [];
    var tmpQueryMData = this.dataSharingService.getQueryMDetailsData();
    if (tmpQueryMData.queryMSearchCriteria != "") {
      this.queryMDetails = tmpQueryMData.queryMDetails;
    }
    this.route.queryParams.subscribe(params => {
      if (params.id == null || params.id == undefined) {
        return;
      }
      this.currMemID = params.id;
    })
    this.fieldWorkDetails = [];
    this.subfieldWorkDetailsData = [];
    this.qualificationDetails = [];
    this.positionDetails = [];
    this.allSubfieldWorkDetailsData = [];
    this.workingOrRetiredArray = [];
    this.businessOrServiceArray = [];

    this.offerService.getFieldWorkDetails().subscribe((res: any) => {
      if (res != null) {
        if (res.status == 1) {
          this.fieldWorkDetails = res['result'];
          this.selectedFieldWorkObj = this.fieldWorkDetails[0];
          this.offerService.getSubFieldWorkDetails().subscribe((res: any) => {
            if (res != null) {
              if (res.status == 1) {
                this.allSubfieldWorkDetailsData = res['result'];
                this.subfieldWorkDetailsData = this.allSubfieldWorkDetailsData.filter(i => i.fieldWorkID === this.fieldWorkDetails[0].fieldWorkID);
                this.selectedSubFieldWorkObj = this.subfieldWorkDetailsData[0];
                this.offerService.getQualificationDetails().subscribe((res: any) => {
                  if (res != null) {
                    if (res.status == 1) {
                      this.qualificationDetails = res['result'];
                      this.selectedQualificationObj = this.qualificationDetails[0];
                      this.offerService.getPositionDetails().subscribe((res: any) => {
                        if (res != null) {
                          if (res.status == 1) {
                            this.positionDetails = res['result'];
                            this.selectedPositionObj = this.positionDetails[0];
                            this.getAllKumiteProfessionData();
                          }
                        }
                      });
                    }
                  }
                });
              }
            }
          });
        }
      }
    });

    this.selectedWorkingOrRetiredObj = {
      id: 0,
      type: "Working"
    };
    this.workingOrRetiredArray.push(this.selectedWorkingOrRetiredObj);
    var tmpObj = {
      id: 1,
      type: "Retired"
    };
   
    this.workingOrRetiredArray.push(tmpObj);
    this.selectedBusinessOrServiceObj = {
      id: 0,
      type: "Service"
    };
    this.businessOrServiceArray.push(this.selectedBusinessOrServiceObj);
    tmpObj = {
      id: 1,
      type: "Business"
    };
    
    this.businessOrServiceArray.push(tmpObj);
  }

  getMemberbyId(id) {
    var tmpArray = [];
    tmpArray = this.queryMDetails;
    tmpArray = tmpArray.filter(function (item) {
      return item.id == id;
    });
    this.formModel.memberName = tmpArray[0].name;
    this.formModel.memberID = tmpArray[0].memberID;
    this.formModel.kumiteProfessionDataID = tmpArray[0].id;
    this.formModel.memberNameDisbaled = tmpArray[0].name;
    this.formModel.memberIDDisbaled = tmpArray[0].memberID;

    this.currMemberItem = tmpArray;
    this.getkumiteProfessionData();
  }

  getkumiteProfessionData() {
    this.formModel.contactNo = "";
    this.formModel.rcc = "";
    this.formModel.groupLead = "";
    this.formModel.fieldofWork = "";
    this.formModel.subField = "";
    this.formModel.qualification = "";
    this.formModel.businessOrService = "";
    this.formModel.position = "";
    this.formModel.workingOrRetired = "";
    this.formModel.specilization = "";
    this.formModel.details1 = "";
    this.formModel.details2 = "";
    this.formModel.details3 = "";
    this.formModel.details4 = "";
    this.formModel.details5 = "";
    this.formModel.details6 = "";
    this.formModel.details7 = "";
    this.formModel.details8 = "";
    this.formModel.details9 = "";
    this.formModel.details10 = "";
    this.formModel.addNewRec = "Y";

    var tmpArray = [];
    tmpArray = this.allKumiteProfessionData;
    var id = this.currMemberItem[0].id;
    tmpArray = tmpArray.filter(function (item) {
      return item.kumiteProfessionDataID == id;
    });
    if (tmpArray.length === 0 ) {
      this.formModel.kumiteProfessionDataID = 0;
      return;
    }
    this.formModel.addNewRec = "N";
    this.formModel.memberID = tmpArray[0].memberID;
    this.formModel.memberName = tmpArray[0].memberName;
    this.formModel.kumiteProfessionDataID = tmpArray[0].kumiteProfessionDataID;
    this.formModel.contactNo = tmpArray[0].contactNo;
    this.formModel.rcc = tmpArray[0].rcc;
    this.formModel.groupLead = tmpArray[0].groupLead;

    var index = this.fieldWorkDetails.findIndex(i => i.fieldWorkDetails === tmpArray[0].fieldofWork);
    this.selectedFieldWorkObj = this.fieldWorkDetails[index];

    this.subfieldWorkDetailsData = this.allSubfieldWorkDetailsData.filter(i => i.fieldWorkID === this.fieldWorkDetails[index].fieldWorkID);
    for (var i = 0; i < this.subfieldWorkDetailsData.length;i++ ) {
      if (this.subfieldWorkDetailsData[i].subFieldWorkDetails === tmpArray[0].subField) {
        this.selectedSubFieldWorkObj = this.subfieldWorkDetailsData[i];
        break;
      }
    }
    this.selectedQualificationObj = this.qualificationDetails.find(i => i.qualificationDetails === tmpArray[0].qualification);
    this.selectedPositionObj = this.positionDetails.find(i => i.positionName === tmpArray[0].position);
    this.selectedBusinessOrServiceObj = this.businessOrServiceArray.find(i => i.type === tmpArray[0].businessOrService);
    this.selectedWorkingOrRetiredObj = this.workingOrRetiredArray.find(i => i.type == tmpArray[0].workingOrRetired);

    this.formModel.fieldofWork = tmpArray[0].fieldofWork;
    this.formModel.subField = tmpArray[0].subField;
    this.formModel.qualification = tmpArray[0].qualification;
    this.formModel.specilization = tmpArray[0].specilization;
    this.formModel.details1 = tmpArray[0].details1;
    this.formModel.details2 = tmpArray[0].details2;
    this.formModel.details3 = tmpArray[0].details3;
    this.formModel.details4 = tmpArray[0].details4;
    this.formModel.details5 = tmpArray[0].details5;
    this.formModel.details6 = tmpArray[0].details6;
    this.formModel.details7 = tmpArray[0].details7;
    this.formModel.details8 = tmpArray[0].details8;
    this.formModel.details9 = tmpArray[0].details9;
    this.formModel.details10 = tmpArray[0].details10;
  }

  getAllKumiteProfessionData() {
    this.offerService.getAllKumiteProfessionData().subscribe((res: any) => {
      if (res.status == 1) {
        this.isLoading = false;
        this.allKumiteProfessionData = res.result;
        this.getMemberbyId(this.currMemID);
      } else {
        this.isLoading = false;
        alert("No records found for given search criteria");
        this.allKumiteProfessionData = [];
        this.getMemberbyId(this.currMemID);
      }
    });
  }

  gotoRecordOffer(searchDirection) {
    let currRecord = 0;
    currRecord = this.currMemberItem[0].id;
    do {
      var tmpArray = [];
      tmpArray = this.queryMDetails;
      switch (searchDirection) {
        case 'F':
          {
            currRecord = tmpArray[0].id;
          }
          break;
        case 'P':
        case 'N':
          {
            var i = 0;
            for (i = 0; i < tmpArray.length; i++) {
              if (tmpArray[i].id == currRecord) {
                break;
              }
            }
            if (searchDirection == 'P') {
              i = i - 1;
              if (i <= 0) {
                currRecord = tmpArray[0].id;
                break;
              }
            }
            if (searchDirection == "N") {
              i = i + 1;
              if (i >= tmpArray.length - 1) {
                currRecord = tmpArray[tmpArray.length - 1].id;
                break;
              }
            }
            currRecord = tmpArray[i].id;
          }
          break;
        case 'L':
          {
            currRecord = tmpArray[tmpArray.length - 1].id;
          }
          break;
        default:
          break;
      }

    } while (false);
    this.getMemberbyId(currRecord);
  }

  onChangeFieldWork(fieldWorkObj) {
    this.subfieldWorkDetailsData = [];
    this.subfieldWorkDetailsData = this.allSubfieldWorkDetailsData.filter(i => i.fieldWorkID === fieldWorkObj.fieldWorkID);
    this.selectedSubFieldWorkObj = this.subfieldWorkDetailsData[0]; 
  }

  onSubmit(form: NgForm) {
    this.formModel.message = "Saving Record";
    if (this.formModel.addNewRec === 'Y') {
      form.value.kumiteProfessionDataID = this.currMemberItem[0].id;
    }
    this.isLoading = true;
    form.value.fieldofWork = form.value.selectedFieldWorkObj.fieldWorkDetails;
    form.value.subField = form.value.selectedSubFieldWorkObj.subFieldWorkDetails;
    form.value.qualification = form.value.selectedQualificationObj.qualificationDetails;
    form.value.position = form.value.selectedPositionObj.positionName;
    form.value.businessOrService = form.value.selectedBusinessOrServiceObj.type;
    form.value.workingOrRetired = form.value.selectedWorkingOrRetiredObj.type;

    this.offerService.SaveKumiteProfessionData(form.value).subscribe((res: any) => {
      if (res.status == 0) {
        this.isLoading = false;
        alert(res.message);
      } else {
        this.isLoading = false;
        this.playAudio();
        this.formModel.message = "RECORD SAVED";

        if (this.formModel.addNewRec === 'Y') {
          this.allKumiteProfessionData.push(form.value);
        } else {
          var i = this.allKumiteProfessionData.findIndex((e) => e.kumiteProfessionDataID === form.value.kumiteProfessionDataID);

          if (i >= 0) {
            this.allKumiteProfessionData[i].rcc = form.value.rcc;
            this.allKumiteProfessionData[i].contactNo = form.value.contactNo;
            this.allKumiteProfessionData[i].groupLead = form.value.groupLead;
            this.allKumiteProfessionData[i].fieldofWork = form.value.fieldofWork;
            this.allKumiteProfessionData[i].subField = form.value.subField;
            this.allKumiteProfessionData[i].qualification = form.value.qualification;
            this.allKumiteProfessionData[i].position = form.value.position;
            this.allKumiteProfessionData[i].businessOrService = form.value.businessOrService;
            this.allKumiteProfessionData[i].workingOrRetired = form.value.workingOrRetired;
            this.allKumiteProfessionData[i].specilization = form.value.specilization;

            this.allKumiteProfessionData[i].details1 = form.value.details1;
            this.allKumiteProfessionData[i].details2 = form.value.details2;
            this.allKumiteProfessionData[i].details3 = form.value.details3;
            this.allKumiteProfessionData[i].details4 = form.value.details4;
            this.allKumiteProfessionData[i].details5 = form.value.details5;
            this.allKumiteProfessionData[i].details6 = form.value.details6;
            this.allKumiteProfessionData[i].details7 = form.value.details7;
            this.allKumiteProfessionData[i].details8 = form.value.details8;
            this.allKumiteProfessionData[i].details9 = form.value.details9;
            this.allKumiteProfessionData[i].details10 = form.value.details10;
          }
        }
        /*
        this.offerService.getAllKumiteProfessionData().subscribe((res: any) => {
          if (res.status == 1) {
            if (this.formModel.addNewRec === 'Y') {
              this.allKumiteProfessionData.push(form.value);
            } else {
              var i = this.allKumiteProfessionData.findIndex((e) => e.kumiteProfessionDataID === form.value.kumiteProfessionDataID);

              if (i > 0 ){
                this.allKumiteProfessionData[i].rcc = form.value.rcc;
                this.allKumiteProfessionData[i].groupLead = form.value.groupLead;
                this.allKumiteProfessionData[i].fieldofWork = form.value.fieldofWork;
                this.allKumiteProfessionData[i].subField = form.value.subField;
                this.allKumiteProfessionData[i].qualification = form.value.qualification;
                this.allKumiteProfessionData[i].position = form.value.position;
                this.allKumiteProfessionData[i].businessOrService = form.value.businessOrService;
                this.allKumiteProfessionData[i].workingOrRetired = form.value.workingOrRetired;
                this.allKumiteProfessionData[i].specilization = form.value.specilization;
                
                this.allKumiteProfessionData[i].details1 = form.value.details1;
                this.allKumiteProfessionData[i].details2 = form.value.details2;
                this.allKumiteProfessionData[i].details3 = form.value.details3;
                this.allKumiteProfessionData[i].details4 = form.value.details4;
                this.allKumiteProfessionData[i].details5 = form.value.details5;
                this.allKumiteProfessionData[i].details6 = form.value.details6;
                this.allKumiteProfessionData[i].details7 = form.value.details7;
                this.allKumiteProfessionData[i].details8 = form.value.details8;
                this.allKumiteProfessionData[i].details9 = form.value.details9;
                this.allKumiteProfessionData[i].details10 = form.value.details10;
              }

            }
            //this.allKumiteProfessionData = res.result;
          }
        });
        */
        setTimeout(() => {
          this.formModel.message = "";
        }, 3000);
      }

     })
  }

 playAudio() {
    let audio = new Audio();
    audio.src = "../assets/audio/beep2.wav";
    audio.load();
    audio.play();
  }
 cancelClick(){
  
   this.router.navigateByUrl("offer/mebo");
 }

}
